import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import {
  GridIcon,
  TimesheetsIcon,
  InsightsIcon,
  ActivityIcon,
  ReportsIcon,
  ProjectManagementIcon,
  PeopleIcon,
  FinancialsIcon,
  SettingsIcon,
} from '../icons'; // Adjust import paths as needed

const sidebarMenu = [
  {
    label: 'Main Menu',
    isTitle: true,
  },
  {
    label: 'Dashboard',
    icon: <GridIcon className="nav-icon" />,
    href: '/',
  },
  {
    label: 'Timesheets',
    icon: <TimesheetsIcon className="nav-icon" />,
    submenu: [
      { label: "View & Edit", href: "/view-and-edit", },
      { label: "Approvals", href: "/approvals", },
    ],
  },
  {
    label: 'Analyze',
    isTitle: true,
  },
  {
    label: 'Insights',
    icon: <InsightsIcon className="nav-icon" />,
    submenu: [
      { label: "Highlights", href: "/highlights", },
      { label: "Performance", href: "/performance", },
      { label: "Unusual activity", href: "/unusual-activity", },
      { label: "Smart notifications", href: "/smart-notifications", },
    ],
  },
  {
    label: "Activity",
    icon: <ActivityIcon />,
    submenu: [
      { label: "Screenshots", href: "/screenshorts", },
      { label: "Apps", href: "/apps", },
      { label: "URLs", href: "/urls", },
    ],
  },
  {
    label: "Reports",
    icon: <ReportsIcon />,
    submenu: [
      { label: "All reports", href: "/reports", },
      { label: "Time & activity", href: "/time-and-activity", },
      { label: "Amounts Owed", href: "/amounts-owed", },
      { label: "Daily totals (Weekly)", href: "/daily-totals", },
      { label: "Work Sessions Report", href: "/WorkSessionsReport", },
      { label: "Apps & URLs report", href: "/apps-urls-report", },
      { label: "Manual Time Edits", href: "/ManualTimeEdits", },
      { label: "Expense Reports", href: "/ExpenseReports", },
      { label: "Timesheet Approvals Report", href: "/timesheet-approvals-report", },
      { label: "Work Break Reports", href: "/WorkBreakReports", },
      { label: "Audit Log", href: "/AuditLog", },
      { label: "Payments", href: "/PaymentsReport", },
      { label: "Weekly Limits Report", href: "/WeeklyLimitsReport", },
      { label: "Daily Limits Report", href: "/DailyLimitsReport", },
      { label: "Project Reports", href: "/ProjectReports", },
      { label: "Client", href: "/client-budgets-report", },
    ],
  },
  {
    label: 'Manage',
    isTitle: true,
  },
  {
    label: "Project Management",
    icon: <ProjectManagementIcon />,
    submenu: [
      { label: "My Projects", href: "/my-projects", },
      { label: "Clients", href: "/clients", },
    ],
  },
  {
    label: "People",
    icon: <PeopleIcon />,
    submenu: [
      { label: "Members", href: "/members", },
      { label: "Teams", href: "/teams", },
    ],
  },
  {
    label: "Financials",
    icon: <FinancialsIcon />,
    submenu: [
      { label: "Invoices", href: "/invoices", },
      { label: "Expenses", href: "/expenses", },
    ],
  },
  {
    label: "Settings",
    icon: <SettingsIcon />,
    submenu: [
      { label: "All settings", href: "/all-settings", },
      { label: "General", href: "/general", },
      { label: "Activity & tracking", href: "/feature", },
      { label: "Billing", href: "/billing", },
    ],
  },
];

const AppSidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <aside className={`sidebar ${isCollapsed ? 'active' : ''}`}>
      <button type="button" className="sidebar-close-btn">
        <span className="icon">×</span>
      </button>

      <div className="sidebar-logo-area">
        <a href="/" className="sidebar-logo">
          <img src="assets/images/logo/logo.svg" alt="logo" className="light-logo" />
          <img src="assets/images/logo/logo.svg" alt="logo" className="dark-logo" />
          <img src="assets/images/logo/logo-icon.svg" alt="icon" className="logo-icon" />
        </a>
      </div>

      <div className="sidebar-menu-area">
        <ul className="sidebar-menu" id="sidebar-menu">
          {sidebarMenu.map((item, index) =>
            item.isTitle ? (
              !isCollapsed && (
                <li key={index} className="sidebar-menu-group-title">
                  {item.label}
                </li>
              )
            ) : (
              <li key={index} className={item.submenu ? 'dropdown' : ''}>
                {item.submenu ? (
                  <>
                    <a className="gap-2" onClick={(e) => e.preventDefault()}>
                      {isCollapsed ? (
                        <Tooltip title={item.label} placement="right">
                          <span>{item.icon}</span>
                        </Tooltip>
                      ) : (
                        <>
                          {item.icon}
                          <span>{item.label}</span>
                        </>
                      )}
                    </a>
                    <ul className="sidebar-submenu pt-0">
                      {item.submenu.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <a href={subItem.href}>
                            {/* <i className={`${subItem.iconClass}`} /> */}
                            {!isCollapsed && subItem.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <a href={item.href} className="gap-2">
                    {isCollapsed ? (
                      <Tooltip title={item.label} placement="right">
                        <span>{item.icon}</span>
                      </Tooltip>
                    ) : (
                      <>
                        {item.icon}
                        <span>{item.label}</span>
                      </>
                    )}
                  </a>
                )}
              </li>
            )
          )}
        </ul>
      </div>

      <div className="sidebarToggal">
        <button type="button" className="sidebar-toggle" onClick={toggleSidebar}>
          <span className="icon text-2xl">
            {/* You can change icon depending on collapse state */}
            <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="28" height="28" rx="14" fill="#E5E8EB"></rect>
              <path
                d="M7.6665 14H20.3332M20.3332 14L15.5832 9.25M20.3332 14L15.5832 18.75"
                stroke="#64748B"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </button>
      </div>
    </aside>
  );
};

export default AppSidebar;
